import React, { useState } from "react";
import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // TODO: Hook this up to backend/email service
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/luxeheights.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            Contact Us
          </h1>
          <p className="text-lg max-w-2xl mx-auto">
            We’d love to hear from you. Get in touch with Aspen Plush Homes today.
          </p>
        </motion.div>
      </section>

      {/* Contact Info + Form */}
      <div className="max-w-7xl mx-auto py-16 px-6 grid md:grid-cols-2 gap-12">
        {/* Left - Contact Info */}
        <div className="space-y-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Get in Touch
          </h2>
          <p className="text-gray-600">
            Whether you’re looking to buy, rent, or simply learn more about our
            developments, we’re here to help.
          </p>
          <div className="flex items-center space-x-4">
            <MapPin className="text-indigo-600" />
            <span>Aspen Plush Homes, Taifa</span>
          </div>
          <div className="flex items-center space-x-4">
            <Phone className="text-indigo-600" />
            <span>+2332773488176</span>
          </div>
          <div className="flex items-center space-x-4">
            <Mail className="text-indigo-600" />
            <span>aspenplushhomes@gmail.com</span>
          </div>
        </div>

        {/* Right - Contact Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-gray-50 p-8 rounded-2xl shadow-lg space-y-6"
        >
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Send us a Message
          </h3>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-600"
            required
          ></textarea>
          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition"
          >
            Send Message
          </button>
        </form>
      </div>

      {/* Optional Google Map */}
      <div className="w-full h-96">
        <iframe
          title="Aspen Plush Homes Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1985.2167184049135!2d-0.24360899999999996!3d5.650263!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9f00161e3067%3A0x6fe543bee3444772!2sLuxe%20Heights%20by%20Aspen%20Plush%20Homes!5e0!3m2!1sen!2sus!4v1757344496740!5m2!1sen!2sus"
          width="100%"
          height="100%"
          allowFullScreen=""
          loading="lazy"
          className="border-0"
        ></iframe>
      </div>
    </div>
  );
}
